import React from "react";
import * as yaml from "js-yaml";
import { validateJson } from "../utils/validateJson";
import DualEditorConvert from "../components/DualEditorConvert";
import AdSenseAd from "../components/AdSenseAd";

const convertJsonToYaml = (input) => {
  const result = validateJson(input);
  if (!result.valid) throw new Error(result.message);
  return yaml.dump(JSON.parse(input));
};

const JsonToYaml = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <h1 className="text-4xl font-bold text-center bg-gradient-to-r from-blue-600 to-indigo-600 text-transparent bg-clip-text mb-2">JSON to YAML Converter</h1>
        <p className="text-gray-500 dark:text-gray-400 text-center max-w-2xl mx-auto mb-6">
        Convert JSON YAML (into human-readable ) format ideal for DevOps and CI/CD workflows.
      </p>
      <DualEditorConvert
        inputLang="json"
        outputLang="yaml"
        convertFn={convertJsonToYaml}
      />
      
      {/* AdSense Ad - Placed below converter */}
      <AdSenseAd adSlot="9698302360" />
    </div>
  );
};

export default JsonToYaml;
